import IDUtils from "../utils/IDUtils";

const parseObjectAsArgs = (object) => {
  const { propPath, value, action, addUndo, source } = object;
  return [propPath, value, action, addUndo, source];
};
class CanvasSetUpdate {
  constructor(canvasSetId) {
    this.id = canvasSetId;
    this.updates = [];
  }

  add(...args) {
    const [propPath, value, updateAction, addUndo, source] =
      typeof args[0] === "object" && !Array.isArray(args[0]) ? parseObjectAsArgs(args[0]) : args;

    const key = Array.isArray(propPath) ? propPath : IDUtils.getArray(propPath);
    let action = false;

    // allow normal update action to be overwritten
    if (updateAction) {
      action = updateAction;
    }

    const update = {
      key,
      value,
      action,
      addUndo,
      source,
    };

    this.updates.push(update);
  }
}

export default CanvasSetUpdate;
